export const MFA_V1_DASHBOARD_PAGE_MAIN_TITLE_ID = 'mfa-dashboard-page-main-title';
export const MFA_V1_DASHBOARD_PAGE_NEW_SESSIONS_LINK_ID = 'mfa-dashboard-page-older-sessions-link';
